import { toDollars } from "../../../helpers/currencies";
import { RollingCubeMotion } from "../RollingCube";
import EmployerStatSummary, {
  EmployerStatSummaryDisplayProps,
} from "./EmployerStatSummary";

const EmployerAverageAnnualSavingsStat = ({
  averageAnnualSavings,
  lifetimePayrollTaxSavings,
  showTitle,
  navigateOnClick,
  config,
  showAlternate,
  motion,
}: {
  averageAnnualSavings: number;
  lifetimePayrollTaxSavings: number;
  showAlternate?: boolean;
  motion?: RollingCubeMotion;
} & EmployerStatSummaryDisplayProps) => {
  return (
    <EmployerStatSummary
      title="Av. Saving / Employee / Yr"
      imageUrl="/analytics/savings-trending.png"
      value={toDollars(averageAnnualSavings, 0)}
      valueColor="secondary.main"
      page="employerViewAnalyticsSavingsSummaries"
      alternate={{
        title: "Lifetime Payroll Tax Savings^",
        value: toDollars(lifetimePayrollTaxSavings, 0),
        valueColor: "primary.main",
        page: "employerViewAnalyticsPayrollTaxSavings",
      }}
      showAlternate={showAlternate}
      motion={motion}
      showTitle={showTitle}
      navigateOnClick={navigateOnClick}
      config={config}
    />
  );
};

export default EmployerAverageAnnualSavingsStat;
